import { Box, Collapse, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import { formatDate, Icons } from '../../../utils/utilities'
import React, { useMemo, useState } from 'react'
import CustomChip from '../../common/CustomChip'

const getMethodColor = ( method ) => {
    switch ( method ) {

        case "GET":
            return "success"

        case "POST":
            return "primary"

        case "PATCH":
        case "PUT":
            return "warning"

        case "DELETE":
            return "error"

        default:
            break
    }
}

const LogsTableRow = ( { log } ) => {

    const [expand, setExpand] = useState( false )
    const { palette, border, layout } = useTheme()

    const requestData = useMemo( () => {
        const data = { exists: false, dataAvailable: [] }
        if ( Object.keys( log?.meta?.body || {} ).length > 0 ) {
            data.body = []
            data.exists = true
            data.dataAvailable.push( "body" )
            for ( const key in log.meta.body ) {
                if ( Object.prototype.hasOwnProperty.call( log.meta.body, key ) ) {
                    data.body.push( { key, value: log.meta.body[key] } )
                }
            }
        }
        if ( Object.keys( log?.meta?.params || {} ).length > 0 ) {
            data.params = []
            data.exists = true
            data.dataAvailable.push( "params" )
            for ( const key in log.meta.params ) {
                if ( Object.prototype.hasOwnProperty.call( log.meta.params, key ) ) {
                    data.params.push( { key, value: log.meta.params[key] } )
                }
            }
        }
        if ( Object.keys( log?.meta?.query || {} ).length > 0 ) {
            data.query = []
            data.exists = true
            data.dataAvailable.push( "query" )
            for ( const key in log.meta.query ) {
                if ( Object.prototype.hasOwnProperty.call( log.meta.query, key ) ) {
                    data.query.push( { key, value: log.meta.query[key] } )
                }
            }
        }
        return data
    }, [log] )


    return ( log.rowType !== 'date' ?
        <>
            <TableRow
                onClick={event => {
                    event.stopPropagation()
                    if ( expand )
                        window.location.href = `#${log._id}`
                    else
                        setExpand( prev => !prev )
                }}
                sx={{
                    cursor: "pointer",
                    position: expand ? "sticky" : "static",
                    top: "34px",
                    zIndex: 10,
                    bgcolor: expand ? palette.contentBg : "",
                    ":hover": { bgcolor: expand ? palette.contentBg : palette.rowHover }
                }}
            >
                <TableCell sx={{ padding: "5px 10px" }}>
                    <Box display="flex" gap="10px" alignItems="center">
                        <IconButton
                            size='small'
                            disabled={!expand}
                            onClick={( event ) => {
                                event.stopPropagation()
                                setExpand( prev => !prev )
                            }}>
                            {!expand ? Icons.default.KeyboardArrowDownIcon : Icons.default.KeyboardArrowUp}
                        </IconButton>
                        <Typography fontSize="12px">{log?.meta?.module || "NA"}</Typography>
                    </Box>
                </TableCell>
                <TableCell sx={{ padding: "5px 10px" }}>
                    <Box display="flex" gap="5px">
                        <CustomChip
                            tooltipTitle='Log level and request status code'
                            color={log.level === "error" ? "error" : "success"}
                            textStyles={{ textTransform: "capitalize" }}
                            value={`${log?.level} (${log?.meta?.statusCode || 500})`}
                        />
                    </Box>
                </TableCell>
                <TableCell sx={{ padding: "5px 10px" }} align="center">
                    <Typography fontSize="12px" >{formatDate( log?.timestamp, { format: "hh:mm A" } )}</Typography>
                </TableCell>
                <TableCell sx={{ padding: "5px 10px", fontSize: "12px" }}>
                    <CustomChip
                        tooltipTitle='Request To'
                        value={log?.meta?.type}
                    />
                </TableCell>
                <TableCell sx={{ padding: "5px 10px" }}>
                    <Box>
                        <Typography fontSize="12px">{log?.message || log?.meta?.error?.message || ""}</Typography>
                    </Box>
                </TableCell>
            </TableRow>
            <TableRow sx={{ overflow: "auto" }}>
                <TableCell sx={{ padding: "0" }} colSpan={5}>
                    <Collapse in={expand} timeout="auto" unmountOnExit>
                        <Box id={log._id} borderTop={border[1]} borderBottom={border[1]} borderRight={border[1]} borderRadius={`0 0 ${layout.borderRadius} ${layout.borderRadius}`} padding="20px">

                            {log?.meta?.user_role && <Box marginBottom="20px"  >
                                <Typography color='textSecondary' variant='subtitle2' display="block">
                                    User Details
                                </Typography>
                                <Box display="flex" gap="5px" alignItems="center" flexWrap="wrap">
                                    <CustomChip value={log.meta.user_name} />
                                    <CustomChip value={log.meta.user_role} />
                                    <CustomChip value={log.meta.empcode || log.meta.user_id} />
                                </Box>
                            </Box>}

                            <Box display={"flex"} gap={layout.sectionsGap} flexWrap="wrap" alignItems="center" >
                                <Box>
                                    <Typography color='textSecondary' variant='subtitle2' display="block">
                                        Request
                                    </Typography>
                                    <Typography border={border[1]} padding="2px 5px 4px 5px" borderRadius="5px" bgcolor={palette.contentBg} display="inline-flex" alignItems="center" gap="5px" variant='subtitle2'>
                                        <Typography fontSize="12px" component="span" fontWeight="600" color={getMethodColor( log?.meta?.method || "GET" )}>{log?.meta?.method || "GET"}</Typography> <Typography fontSize="inherit" fontWeight="inherit" component="span" color='textSecondary' >|</Typography> {log.meta?.endpoint}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography color='textSecondary' variant='subtitle2' display="block">
                                        Source File
                                    </Typography>
                                    <Typography border={border[1]} padding="2px 5px 4px 5px" borderRadius="5px" bgcolor={palette.contentBg} variant='subtitle2'>{log.meta?.file?.split( "\\" ).at( -1 )}</Typography>
                                </Box>
                                <Box>
                                    <Typography color='textSecondary' variant='subtitle2' display="block">
                                        Controller Name
                                    </Typography>
                                    <Typography border={border[1]} padding="2px 5px 4px 5px" borderRadius="5px" bgcolor={palette.contentBg} variant='subtitle2'>{log.meta.handler}</Typography>
                                </Box>
                                {/* <Typography> <strong>File: </strong> <em> {log.meta?.file?.split( "\" ).at( -1 )} <strong>{log.meta?.handler ? `[${log.meta.handler}]` : ""}</strong></em> </Typography>
                                < Typography textTransform="capitalize" > <strong>User: </strong> <em>{log.meta?.user_name?.toLowerCase()}  ({log.meta?.user_id || "NA"}-{log.meta?.user_id || "NA"} ), {log.meta?.user_role}</em> </Typography> */}
                            </Box>

                            {requestData.exists && <Box display="flex" gap="20px" flexWrap="wrap" width="90%" >
                                {requestData.dataAvailable.map( data => (
                                    <Box maxWidth="300px" key={data}>
                                        <Typography marginY="10px" variant='subtitle1' sx={{ fontWeight: "bold" }}>{data}</Typography>
                                        <TableContainer>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ border: border[1], padding: "5px 10px", fontSize: "12px" }}>Key</TableCell>
                                                        <TableCell sx={{ border: border[1], padding: "5px 10px", fontSize: "12px" }}>Value</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {requestData[data].map( ( { key, value } ) => (
                                                        <TableRow key={key}>
                                                            <TableCell sx={{ border: border[1], padding: "5px 10px", fontSize: "12px" }}>{key}</TableCell>
                                                            <TableCell sx={{ border: border[1], padding: "5px 10px", fontSize: "12px" }}>{typeof value === 'string' ? value : JSON.stringify( value, null, 2 )}</TableCell>
                                                        </TableRow>
                                                    ) )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                ) )}
                            </Box>}

                            {( log?.meta?.error?.stack || log?.meta?.error?.message ) && <Box marginTop="20px" borderRadius="5px" border={border[1]} >
                                <Typography padding="5px 10px" fontSize="14px" bgcolor={palette.contentBg} color="error.main">ERROR</Typography>
                                {log?.meta?.error?.stack ? <Box overflow="auto" color={palette.text.secondary} fontSize="12px" fontWeight="400" fontFamily="monospace" className='custom-scrollbar' padding="10px" component="pre" flexGrow={1}>
                                    {typeof log.meta.error.stack === 'string' ? log.meta.error.stack : JSON.stringify( log.meta.error.stack, null, 2 )}
                                </Box> : <Box overflow="auto" color={palette.text.secondary} fontSize="12px" fontWeight="400" fontFamily="monospace" className='custom-scrollbar' padding="10px" component="pre" flexGrow={1}>
                                    {log?.meta?.error?.message}
                                </Box>}
                            </Box>}

                            {log?.meta?.type === "API" && log?.meta?.errorData && <Box marginTop="20px" borderRadius="5px" border={border[1]} >
                                <Typography padding="5px 10px" fontSize="14px" bgcolor={palette.contentBg} color="greyed.main">API RESPONSE</Typography>
                                <Box overflow="auto" color={palette.text.secondary} fontSize="12px" fontWeight="400" fontFamily="monospace" className='custom-scrollbar' padding="10px" component="pre" flexGrow={1}>
                                    {typeof log.meta.errorData === 'string' ? log?.meta?.errorData : JSON.stringify( log.meta.errorData, null, 2 )}
                                </Box>
                            </Box>}

                            {log?.meta?.data && <Box display="flex" flexDirection="column" overflow="auto" maxHeight="300px" marginTop="20px" borderRadius="5px" border={border[1]} >
                                <Typography padding="5px 10px" fontSize="14px" bgcolor={palette.contentBg} color="greyed.main">RESPONSE</Typography>
                                <Box overflow="auto" color={palette.text.secondary} fontSize="12px" fontWeight="400" fontFamily="monospace" className='custom-scrollbar' padding="10px" component="pre" flexGrow={1}>
                                    {log?.meta?.message}
                                    {typeof log.meta.data === 'string' ? JSON.stringify( JSON.parse( log.meta.data ), null, 2 ) : JSON.stringify( log.meta.data, null, 2 )}
                                </Box>
                            </Box>}
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </> : <TableRow sx={{ position: "sticky", borderTop: border[1], top: 34, bgcolor: palette.contentBg, zIndex: 10, }}>
            <TableCell sx={{ padding: "5px" }} align="center" colSpan={10}>
                <Box display="flex" alignItems="center" gap="20px">
                    <Box flexGrow={1} borderRadius="1px" height="1px" bgcolor={palette.greyedOut}></Box>
                    <Typography textAlign="center" ><em>{formatDate( log.date, { format: "dddd, MMMM D, YYYY" } )}</em></Typography>
                    <Box flexGrow={1} borderRadius="1px" height="1px" bgcolor={palette.greyedOut}></Box>
                </Box>
            </TableCell>
        </TableRow>
    )
}

export default LogsTableRow
